import React from "react";
//#region types
import { SelectInputItemProps, SelectInputProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { Autocomplete } from "@mui/material";
import useAutoCompleteCommonProps from "./useAutoCompleteCommonProps";
import BaseInput from "./baseInput";
//#endregion

const SelectInput: React.FC<SelectInputProps> = (props) => {
  const onChange = (event: any, newValue: SelectInputItemProps | null) => {
    props.setValue(newValue?.value ?? undefined, true);
    props.setTouched(true, false);
  };

  const commonProps = useAutoCompleteCommonProps(
    props.disabled,
    props.hasError,
    undefined,
    undefined,
    undefined,
    props.rootClass
  );

  return (
    <Autocomplete
      {...commonProps}
      id={`autoComplete-${props.name}`}
      options={props.items ?? []}
      getOptionLabel={(option) => option.label}
      loading={props.items === undefined}
      getOptionDisabled={(option) => !!option.disabled}
      value={props.items?.find((x) => x.value === props.value) ?? null}
      onChange={onChange}
      disabled={props.disabled}
      readOnly={props.readonly}
      forcePopupIcon={props.hideDropdownIcon ? false : undefined}
      groupBy={(option) => (option.group === undefined ? "" : `${option.group}`)}
      renderInput={(params) => (
        <BaseInput
          type="text"
          name={props.name}
          icon={props.icon}
          value={props.value}
          label={props.label}
          placeholder={props.placeholder}
          setValue={() => {}}
          touched={props.touched}
          setTouched={props.setTouched}
          hasError={props.hasError}
          onChange={params.inputProps.onChange ?? (() => {})}
          onBlur={() => {}}
          inputProps={{
            ...params.inputProps,
            ...(props.ariaDescribedBy ? { "aria-describedby": props.ariaDescribedBy } : {}),
          }}
          InputProps={params.InputProps}
          className={props.className}
          isLoading={props.loading}
          optional={props.optional}
          disabled={props.disabled}
          readonly={props.readonly}
          readonlyStyle={props.readonlyStyle}
          endAdornment={props.endAdornment}
          browserAutocompleteOff
        />
      )}
      data-testid={`${props.name}SelectInput`}
    />
  );
};

export default SelectInput;
